import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { getAuthValue } from "../../authModule/hooks/useAuthValue";

type VotePayload = {
    cptId: number | string;
    liked: boolean;
    additionalFeedback?: string;
    caseId?: string;
    hospitalId:string,
    apiType?: string,
};

function voteCpt(payload: VotePayload) {
    const { cptId, liked, additionalFeedback, caseId, hospitalId,apiType } = payload;
    const { tenantId } = getAuthValue();        
        const url =
        apiType === "HCPCS"
          ? `analytics/${caseId}/hcpcs-codes/${cptId}`
          : `analytics/${caseId}/cpt-codes/${cptId}`;
    return fetcher({
        url,
        method: "PATCH",
        headers: {
            "x-hospital-id": hospitalId,
            "x-tenant-id": tenantId,
        },
        data: {
            liked,
            ...(additionalFeedback ? { additionalFeedback } : {}),
        },
    });
}

export function useCptRateMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: voteCpt,
        onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: ["GET_ALL_CPTS_QUERY_KEY"],
                });
        },
    });
}
